export default "__VITE_ASSET__1bb76d9a__"